const { css } = require('styled-components');

const ENABLE_FIELD_HOVER_HIGHLIGHT = false;

const internals = {};

internals.enabledHoverFieldHighlightStyles = css`
    &:hover .MuiFormLabel-root,
    &:hover .MuiInputLabel-root {
        color: ${({ theme }) => theme.palette.primary.main};
    }

    &:hover .MuiInputBase-input::placeholder,
    &:hover .MuiAutocomplete-input::placeholder {
        color: ${({ theme }) => theme.palette.primary.main};
        opacity: 0.78;
    }

    &:hover .MuiInput-underline:before,
    &:hover .MuiInput-underline:hover:not(.Mui-disabled):before {
        border-bottom-color: ${({ theme }) => theme.palette.primary.main};
    }
`;

module.exports = ENABLE_FIELD_HOVER_HIGHLIGHT
    ? internals.enabledHoverFieldHighlightStyles
    : null;
